import styled from 'styled-components'
import { colorTheme } from '../../../style/theme/colorTheme'

export const FolioMarkerWrap = styled.div`
	font-size: inherit;
	display: grid;
	place-items: center;
	flex-shrink: 0;
	width: 1.25em;
	height: 1.25em;
	border-radius: 50%;
	background: ${colorTheme.roomCharge.marker.background};
	color: ${colorTheme.roomCharge.marker.icon};

	> svg {
		width: 0.75em;
		height: 0.75em;
		fill: currentColor;
	}
`
FolioMarkerWrap.displayName = 'FolioMarkerWrap'
